import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import DesignHubRepository from "src/repository/DesignHubRepository";

const slice = createSlice({
    name: "DesignHub",
    initialState: {
       
    },
    reducers: {
 
    },
    extraReducers: {
       
    },
});



export let {  } = slice.actions;

export default slice.reducer;
